import PropTypes from 'prop-types';
import React from 'react';
import ImageSlider from './ImageSlider';
import css from './UGC.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var UGC = function UGC(_ref) {
  var images = _ref.images,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx(ImageSlider, {
      images: images,
      showInsetCaptions: true
    })]
  });
};

var imageProps = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}).isRequired;
UGC.propTypes = {
  images: PropTypes.arrayOf(imageProps).isRequired,
  title: PropTypes.string.isRequired
};
export default UGC;